export function formatPolicyNumber(policyNumber: string): string {
  const [main, subnumber] = policyNumber.split('/');
  const [prefix, number] = main.split('.');
  const paddedNumber = number.padStart(6, '0');
  const formattedPolicyNumber = `${prefix}.${paddedNumber}`;

  return subnumber ? `${formattedPolicyNumber}/${subnumber}` : formattedPolicyNumber;
}
